/*
 * @Author: liujie09
 * @Date: 2021-07-29 14:32:35
 * @Description: some description
 * @LastEditTime: 2021-11-23 14:46:25
 * @FilePath: /kast/packages/bus/src/cache.ts
 */
const namespace = 'KASTJS';

export const setCache = (key: string, value: any): void => {
  if (!(window as any)[namespace]) {
    (window as any)[namespace] = {};
  }
  (window as any)[namespace][key] = value;
};

export const getCache = (key: string): any => {
  const cache: any = (window as any)[namespace];
  return cache && cache[key] ? cache[key] : null;
};
